export function errorHandler(error, openModal) {
  if (error.name === 'AbortError') {
    return;
  }
  if (error.trackingId) {
    openModal('api-error-modal', {
      message: error.message,
      trackingId: error.trackingId,
      name: error.name,
      errors: error.errors,
      code: error.errorCode,
    });
  }
}

export default errorHandler;
